import { observer } from 'mobx-react';
import React from 'react';

import ToolbarReloadButton from 'components/UI/ToolbarReloadButton';
import store from 'stores/RootStore';

// similar to client/src/components/Views/Tearsheet/Shared/AdView/AdViewToolbar/ReloadButton.tsx

function ReloadButton() {
  const currentAd = store.creative?.ads.current;

  // Was `disabled={!!currentAd}` - disabled exactly when there was an ad to
  // reload, and enabled only when the handler could do nothing. Inverted
  // since 9b5061a1 (2022-09-19), the commit that wired up reload() and
  // replaced a hardcoded `disabled` with a computed one; but it was
  // apparently flipped, so the button was unavailable when it was able to
  // do something, and available when not - whereupon the onClick handler
  // with the ?. would not do anything.
  const canReload = !!currentAd;

  // Note that this true only while `status === DocumentStatus.LOADING`,
  // i.e. during the Firestore document fetch, so in practice it is false by
  // the time this toolbar is on screen, thus the spinner is close to
  // unreachable.
  //
  // Browser-style "click, spin until HTML load completes" would need a
  // signal that does not exist at the time of writing: AdViewFrame
  // reporting the iframe's load event into somewhere the toolbar can see,
  // most naturally a flag on Ad set when RELOAD is dispatched and cleared
  // when the frame reports back.  That is new plumbing, deliberately out of
  // scope here. This makes do with what we have.
  const isLoading = !!currentAd?.loading;

  return (
    <ToolbarReloadButton
      disabled={!canReload}
      isBusy={isLoading}
      onClick={() => currentAd?.reload()}
    />
  );
}

export default observer(ReloadButton);
